import { DaoService } from "./DaoService";

export class CommentaireService extends DaoService {
  static getInstance() {
    return super.getInstance("commentaire");
  }

  async update(uid, data) {
    return CommentaireService.put(`${this.prefix}/${uid}`, data);
  }

  async findByParent(parentId, parentType) {
    const data = { parent_type: parentType };
    return CommentaireService.post(`${this.prefix}/${parentId}/parent`, data);
  }

  async search(data) {
    return CommentaireService.post(`${this.prefix}/search`, data);
  }

}
